<template>
  <v-btn
    variant="flat"
    :loading="resetBtnLoading"
    @click="recreateCanvasProDeviceConfig"
    color="error"
    prepend-icon="mdi-refresh">
    Reset Config
  </v-btn>
</template>
<script setup>
import { ref } from 'vue';
import { $http } from '../../../../stores/http';
import { getGPUInfo } from '../../../../utils/ventuzConfig';
const resetBtnLoading = ref(false);

const emit = defineEmits(['updateGPUS', 'updateConfig', 'updateConfigName']);

async function recreateCanvasProDeviceConfig() {
  resetBtnLoading.value = true;
  const confirmed = confirm(
    `This will delete your Device Configuration called "CanvasPro" (if it exists), and create a fresh new one.\n\n(This does not set a GPU or Output, you will need to choose one again.)\n\nThis should only be used if something has broken.\n\nAre you sure you want to continue?`
  );

  if (!confirmed) {
    resetBtnLoading.value = false;
    return;
  }

  let data = await $http('GET', `/dynamic_engine/device_config/reset`);
  data = JSON.parse(data);

  emit('updateConfig', data['config']);
  emit('updateConfigName', data['config_name']);
  emit('updateGPUS', await getGPUInfo());
  resetBtnLoading.value = false;
  return data;
}
</script>
<style scoped></style>
